import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-expiration-notice-modal',
  templateUrl: './expiration-notice-modal.component.html',
  styleUrls: ['./expiration-notice-modal.component.scss']
})
export class ExpirationNoticeModalComponent {

  @Input() problem: 'long-expired' | 'expired' | 'will-expire' = "expired";

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  onCancelClick() {
    this.activeModal.dismiss(0);
  }

  onActionClick() {
    this.activeModal.close(true);
  }

}
